import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { missingEnv } from './config';
import { initIdentity } from './identity';
// Sichert die Auth-Parameter aus der URL, bevor supabase-js sie wegraeumt.
import './lib/authLink';
import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root fehlt in index.html');

const missing = missingEnv();
if (missing.length === 0) initIdentity();

createRoot(container).render(
  <StrictMode>
    {missing.length > 0 ? (
      <div className="login">
        <div className="login__card">
          <h1>Konfiguration fehlt</h1>
          <p className="card__meta">
            Diese Env-Variablen sind im Build nicht gesetzt: {missing.join(', ')}. In Netlify unter
            Site configuration → Environment variables ergänzen und neu deployen.
          </p>
        </div>
      </div>
    ) : (
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    )}
  </StrictMode>,
);
